import { Http } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import 'ckeditor';

declare var CKEDITOR: any;

CKEDITOR.dtd.$removeEmpty['span'] = false;

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { DisplayModule } from './modules/display';

import { CrudService } from '@shared/services';

import { ROUTES } from './admin.routes';
import { SIDEBAR_TOGGLE_DIRECTIVES, NAV_DROPDOWN_DIRECTIVES, AsideToggleDirective } from './directives';
import { CanActivateViaAdminGuard } from './route-guards';
import { AdminComponent } from './admin.component';
import { LayoutComponent } from './components/layout';
import { BreadcrumbsComponent, UnderConstructionComponent } from './components';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http) {
  return new TranslateHttpLoader(http, './assets/admin/i18n/', '.json');
}

@NgModule({
  declarations: [
    SIDEBAR_TOGGLE_DIRECTIVES,
    NAV_DROPDOWN_DIRECTIVES,
    AsideToggleDirective,
    AdminComponent,
    BreadcrumbsComponent,
    UnderConstructionComponent,
    LayoutComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule.forChild(ROUTES),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [
          Http
        ]
      }
    }),
    DisplayModule
  ],
  providers: [
    CanActivateViaAdminGuard,
    CrudService
  ]
})
export class AdminModule {
  constructor() {
    // var CKEDITOR: any;

    // CKEDITOR.dtd.$removeEmpty['span'] = false;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/admin.module.ts